<template>
  <main>
    <router-view></router-view>
  </main>
</template>

<script src="./MainContent.script.ts" lang="ts"></script>
<style src="./MainContent.styles.scss" scoped lang="scss"></style>
